import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { AdvancedFondListComponent, FundsVisibility } from '@components/advanced-fond-list/advanced-fond-list.component';
import { FondsportraitComponent } from '@components/fondsportrait/fondsportrait/fondsportrait.component';
import { RouteSelectedFund } from '@components/fondsportrait/selected-fund';
import { ShadowStylesDirective } from 'src/boilerplate/shadow-styles.directive';

type DisplayableComponent = 'fondsportrait' | 'fondslist';

@Component({
  selector: 'rpt-fonds-list-fondsportrait-combo',
  standalone: true,
  imports: [FondsportraitComponent, AdvancedFondListComponent],
  templateUrl: './fonds-list-fondsportrait-combo.component.html',
  styleUrl: './fonds-list-fondsportrait-combo.component.scss',
  hostDirectives: [ShadowStylesDirective],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class FondsListFondsportraitComboComponent {
  @Input({ required: false, alias: 'force-displayed-component' })
  public set setForceDisplayedComponent(value: unknown | undefined) {
    this.forceDisplayedComponent = value as DisplayableComponent | undefined;
  }

  @Input({ required: false, alias: 'fondslist-display-user-fonds-button' })
  public set setFondslistDisplayUserFondsButton(value: unknown | undefined) {
    this.fondslistDisplayUserFondsButton = value === true || value === 'true';
  }

  @Input({ required: false, alias: 'fondslist-control-via-url' })
  public set setFondslistControlViaUrl(value: unknown | undefined) {
    this.fondslistControlViaUrl = value === true || value === 'true';
  }

  @Input({ required: false, alias: 'fondslist-initial-funds-visibility' })
  public set setForceInitialFundsVisibility(value: FundsVisibility | undefined) {
    if (value !== 'user' && value !== 'public' && value !== 'special') {
      return;
    }

    this.fondslistInitialFundsVisibility = value as FundsVisibility;
  }

  @Input({ required: false, alias: 'fondslist-redirect-url' })
  public set setFondslistRedirectUrl(value: string | undefined) {
    if (value) {
      this.fondslistRedirectUrl = value;
    }
  }

  @Input({ required: false, alias: 'combo-high-z-index' })
  public set setComboHighZIndex(value: string | undefined) {
    this.comboHighZIndex = value === 'true' ? true : false;
  }

  protected forceDisplayedComponent: DisplayableComponent | undefined;
  protected fondslistDisplayUserFondsButton: boolean = false;
  protected fondslistControlViaUrl: boolean = false;
  protected fondslistInitialFundsVisibility: FundsVisibility = 'public';
  protected fondslistRedirectUrl: string = '';

  protected comboHighZIndex: boolean = true;

  protected readonly selectedFunds = inject(RouteSelectedFund).refresh().get();

  protected shouldDisplayFondsportrait(): boolean {
    return this.forceDisplayedComponent === 'fondsportrait' || (this.forceDisplayedComponent !== 'fondslist' && !!this.selectedFunds);
  }
}
